import { useContext, useEffect, useReducer, useState } from 'react';

import { Filters } from './../components/CommonInputs';
import { Results } from './Results';
import { ActiveFilters } from './ActiveFilters';
import { ExploreSearchActions, ExploreSearchContext, ExploreSearchReducer, GenericTransactionManager, initialExploreSearchState, transactionalExploreSearchReducer } from '../states/ExploreSearchState';
import { AppMessagesContext } from '@viamap/viamap2-common';
import { ProjectContext } from 'src/states/ProjectState';
import { PropertyInfoView } from 'src/propertyInfoTemplates/PropertyInfoView';
import { ADModalBodyNoScroll, AdvancedDragModal } from 'src/componentsUtils/AdvancedDragModal';
import { GlassCard } from 'src/components/MitGlassComponents';
import { useWindowContext } from 'src/WindowManager/useWindowContext';
import { closeWindow, ManagedWindow, WindowId } from 'src/WindowManager/WindowState';

export const SearchWindow = (props: { managedWindow: ManagedWindow, callbackOnClose: () => void }) => {
  const [state, dispatch] = useReducer(ExploreSearchReducer, initialExploreSearchState());
  const [viewInfoBox, setViewInfoBox] = useState(0)
  const [bfeNr, setViewBFEnr] = useState<string>("")
  const { dispatch: WindowDispatch } = useWindowContext();

  const { state: projState, dispatch: projDispatch } = useContext(ProjectContext)
  const { dispatch: appMsgDispatch } = useContext(AppMessagesContext)

  // const { state, dispatch } = useContext(ExploreSearchContext);

  function bfeHandler(a, b) {
    setViewInfoBox(a);
    setViewBFEnr(a);
  }

  useEffect(() => {
    setViewBFEnr(bfeNr)
  }, [bfeNr])

  return (
    <ExploreSearchContext.Provider value={{ state: state, dispatch: GenericTransactionManager.dispatchMiddleware<ExploreSearchActions>(dispatch, transactionalExploreSearchReducer) }}>
      <AdvancedDragModal
        window={props.managedWindow}
        PosDefault={{ left: "200px", top: "50%", transform: "translateY(-50%)", height: "800px", width: "1000px" }}
        PosDefaultNS={{ width: "calc( 100% - 30px )", height: "calc(100% - 50px)", top: "50px", left: "15px" }}
        saveKey="Explore"
        title={"Explore"}
        allowUserMiniMize
        allowFullscreen
        onClose={() => WindowDispatch(closeWindow(WindowId.Explore))}
      >
        <ADModalBodyNoScroll
          templateRows={
            !viewInfoBox ?
              "minmax(300px, 20%) 1fr" :
              "50% 50%"
          }
        >

          {!viewInfoBox ? <>
            <Filters />
          </> : null}
          <div className='glassColumn'>
            <ActiveFilters />
            <Results selectBFECallback={(a, b) => bfeHandler(a, b)} callBackOnClose={() => setViewInfoBox(0)} showClose={Boolean(viewInfoBox)} />
          </div>
          {viewInfoBox ? <>
            <div className='glassColumn'>
              <GlassCard
                style={{ height: "100%" }}
                title={"Ejendom"}
              >
                <PropertyInfoView
                  key={bfeNr}
                  foldetUd={true}
                  cols={1}
                  bfeNr={bfeNr}
                  callBackOnLoaded={() => { }}
                  allowExtendedInformation={true}
                />
              </GlassCard>
            </div>
          </> : null}
        </ADModalBodyNoScroll>
      </AdvancedDragModal>
    </ExploreSearchContext.Provider>
  );
}



